import { createSelector } from 'reselect'
import { RootState } from 'src/redux/createRootReducer'
import { selectUserIdFromState } from 'src/redux/selectors/auth.selectors'
import { selectVirtualCardListModels } from 'src/redux/selectors/data/virtualCards.selectors'
import { UsersFullPaginatedDataState } from 'src/redux/usersFullPaginatedData.reducer'
import { VirtualCardsFullPaginatedDataState } from 'src/redux/virtualCardsFullPaginatedData.reducer'

export const selectUsersFullPaginatedDataFromState = (
  state: RootState,
): UsersFullPaginatedDataState =>
  state.app.yourCards.yourCardsInactive.usersFullPaginatedData

export const selectVirtualCardsFullPaginatedData = (
  state: RootState,
): VirtualCardsFullPaginatedDataState =>
  state.app.yourCards.yourCardsInactive.virtualCardsFullPaginatedData

const selectUniqueVirtualCardIds = createSelector(
  [selectVirtualCardsFullPaginatedData],
  (data) => data.ids.filter((id, i) => data.ids.indexOf(id) === i),
)
const selectUniqueVirtualCardListModels = createSelector(
  [selectUniqueVirtualCardIds, selectVirtualCardListModels],
  (ids, virtualCards) => ids.map((id) => virtualCards[id]),
)
export const selectFilteredVirtualCards = createSelector(
  [selectUniqueVirtualCardListModels, selectUserIdFromState],
  (virtualCards, userId) =>
    virtualCards.filter(
      (vc) =>
        vc.isInactive &&
        vc.recipientId === userId &&
        vc.creditCardId !== undefined,
    ),
)
